import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useRouteMatch } from "react-router-dom";
import SyntaxHighlighter from "react-syntax-highlighter";
import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";
import {
  Button,
  Input,
  FormGroup,
  Col,
  Row,
  Container,
  Label,
} from "reactstrap";
import ApiCaller from "api/apiCaller";
import Loading from "components/Loading";
import Constant from "constants";
import style from "react-syntax-highlighter/dist/esm/styles/hljs/agate";
import Select from "react-select";

import "./index.css";
import api from "api";
import { NewUser } from "model/user";
import { ApiResponse } from "model/response";
import { Popup } from "components/Popup";

interface ModalData {
  isOpen: boolean;
  title: string;
  type: string;
  description: string;
  onPressSubmit: Function;
  onPressCancel: Function;
}

export default function UserEdit(props: any) {
  const match = useRouteMatch("/user/:user_id");
  const params: any = match?.params;
  const userId = params?.userId;
  const [loading, setLoading] = useState(true);

  const isEdit = userId ? true : false;
  const companyId: any = api.getCurrentCompanyId();
  const [currentUser, setCurrentUser] = useState<any>({});
  // Schedule Query Data
  const [userData, setUserData] = useState<NewUser>({
    first_name: "",
    last_name: "",
    password: "",
    username: "",
    email: "",
    company_id: companyId,
  });

  const [confirmPassword, setConfirmPassword] = useState<string>("");

  const [modalData, setModalData] = useState<ModalData>({
    isOpen: false,
    title: "",
    type: "error",
    description: "",
    onPressCancel: () => {},
    onPressSubmit: () => {},
  });

  useEffect(() => {
    initData();
  }, []);

  const initData = async () => {
    const user = api.getCurrentUser();
    setCurrentUser(user);
    setLoading(false);
  };

  const onSubmit = async () => {
    const { first_name, last_name, username, password, email } = userData;
    if (password != confirmPassword) {
      setModalData({
        isOpen: true,
        title: "Error",
        type: "error",
        description: "Please check your password",
        onPressSubmit: () => {
          setModalData({ ...modalData, ...{ isOpen: false } });
        },
        onPressCancel: () => {
          setModalData({ ...modalData, ...{ isOpen: false } });
        },
      });
      return;
    }
    if (
      first_name === "" ||
      last_name === "" ||
      username === "" ||
      password === "" ||
      email === ""
    ) {
      setModalData({
        isOpen: true,
        title: "Error",
        type: "error",
        description: "Please check your password",
        onPressSubmit: () => {
          setModalData({ ...modalData, ...{ isOpen: false } });
        },
        onPressCancel: () => {
          setModalData({ ...modalData, ...{ isOpen: false } });
        },
      });
      return;
    }
    setLoading(true);
    if (isEdit) {
    } else {
      const res: ApiResponse = await ApiCaller.post(`user`, userData);
      if (res?.status === "ok") {
        // setLoading(false);
        props.history.goBack();
      } else {
        setLoading(false);
        setModalData({
          isOpen: true,
          title: "Error",
          type: "error",
          description: res?.message,
          onPressSubmit: () => {
            setModalData({ ...modalData, ...{ isOpen: false } });
          },
          onPressCancel: () => {
            setModalData({ ...modalData, ...{ isOpen: false } });
          },
        });
      }
    }
  };

  if (loading) return <Loading />;

  return (
    <Container>
      <Popup
        type={modalData?.type}
        isOpen={modalData?.isOpen}
        title={modalData?.title}
        description={modalData?.description}
        onPressSubmit={modalData?.onPressSubmit}
        onPressCancel={modalData?.onPressCancel}
      />
      <Row>
        <Col xs={12}>
          <FormGroup>
            <Label>First Name (*)</Label>
            <Input
              type="text"
              value={userData?.first_name}
              onChange={(e) => {
                setUserData({
                  ...userData,
                  ...{ first_name: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Last Name (*)</Label>
            <Input
              type="text"
              value={userData?.last_name}
              onChange={(e) => {
                setUserData({
                  ...userData,
                  ...{ last_name: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Username (*)</Label>
            <Input
              type="text"
              value={userData?.username}
              onChange={(e) => {
                setUserData({
                  ...userData,
                  ...{ username: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Email (*)</Label>
            <Input
              type="text"
              value={userData?.email}
              onChange={(e) => {
                setUserData({
                  ...userData,
                  ...{ email: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Password (*)</Label>
            <Input
              type="password"
              value={userData?.password}
              onChange={(e) => {
                setUserData({
                  ...userData,
                  ...{ password: e.target.value },
                });
              }}
            />
          </FormGroup>
        </Col>
        <Col xs={12}>
          <FormGroup>
            <Label>Confirm Password (*)</Label>
            <Input
              type="password"
              value={confirmPassword}
              onChange={(e) => {
                setConfirmPassword(e.target.value);
              }}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <div style={styles.controls}>
            <Button color="primary" onClick={onSubmit}>
              {isEdit ? "Save changes" : "Create"}
            </Button>{" "}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

const styles: { [name: string]: React.CSSProperties } = {
  controls: {
    marginTop: 12,
    marginBottom: 12,
  },
  info: {
    marginTop: 12,
    marginBottom: 12,
  },
  infoHeading: {
    fontWeight: 700,
  },
  queryContainer: {
    marginTop: 12,
  },
};
